export default __webpack_public_path__ + "static/media/Library-documentation.8e2a0f37.md";